export type PrepaidItemType = 'subscription' | 'product';

export type PrepaidItem = {
  type: PrepaidItemType;
  ID: number;
  name: string;
  purchase_date: string | null; // YYYY-MM-DD
  comments: string | null;
  display_status: 'Active' | 'Pending' | 'Cancelled' | 'Inactive';
  status_detail: string | null; // "Started on 2026-05-01" | "Cancelled on 2026-03-01"
};

export type SubscriptionJob = {
  ID: number;
  appointment: string;
  job_type: 'O' | 'R' | 'S';
  labour_hours_total: number;
};

export type SubscriptionInvoice = {
  ID: number;
  customer_service_ID: number;
  plan_description: string;
  duedate: string;
  date: string;
  total: string;
  payment_received: string;
};

export type BillingServiceType = { ID: number; service_name: string };

export type BillingPlan = { ID: number; description: string; cost: string };

export const JOB_TYPE_LABELS: Record<SubscriptionJob['job_type'], string> = {
  O: 'On-Site',
  R: 'Remote',
  S: 'Parts Only',
};
